import { useBlockSupportStore } from '@components/Settings/BlockSupport/BlockSupportStore';
import { useSelect } from '@wordpress/data';

export const allowedBlockbiteBlock = (blockname: any) => {
  const { disallowed } = useBlockSupportStore.getState();
  const isDisallowed = disallowed === null ? [] : disallowed;
  if (isDisallowed.includes(blockname)) {
    return false;
  } else {
    return true;
  }
};

export const isLayoutVisualBlock = (blockname: any) => {
  const supportLayout = [
    'blockbite/section',
    'blockbite/group',
    'blockbite/advanced-button',
    'blockbite/canvas',
    'blockbite/carousel',
    'blockbite/carousel-slide',
    'blockbite/bites-wrap',
    'blockbite/ai-generated',
  ];
  const supportMedia = [
    'blockbite/section',
    'blockbite/group',
    'blockbite/canvas',
    'blockbite/visual',
  ];

  return {
    layout: supportLayout.includes(blockname),
    visual: supportMedia.includes(blockname),
  };
};

export const useIsSelectedOrChild = (clientId: string, isSelected: any) => {
  // @ts-ignore
  let isSelectedOrChild = useSelect((select: any) =>
    select('core/block-editor').hasSelectedInnerBlock(clientId)
  );
  if (!isSelectedOrChild && isSelected !== null) {
    isSelectedOrChild = isSelected;
  }
  return isSelectedOrChild;
};
